import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor() { }

  get authApiURI() {
    return 'https://localhost:44343/api';
  }

  get resourceApiURI() {
    return 'https://localhost:44300/api';
    //return 'http://localhost:52186/api'
    //return 'http://localhost:53752/api';
    //return 'http://localhost:61551/api';
    //return 'https://localhost:44325/api';
  }
}
